module.exports = __webpack_public_path__ + "static/img/infos-1-fr.7f75e1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/infos/img/infos-1-fr.png
// module id = 7sEB
// module chunks = 1